export default "__VITE_ASSET__0ea30f51__"